export var KeyGenerator;
(function (KeyGenerator) {
    KeyGenerator["AutoIncrement"] = "auto-increment";
})(KeyGenerator || (KeyGenerator = {}));
export var KeyCompareOp;
(function (KeyCompareOp) {
    KeyCompareOp["Equals"] = "=";
    KeyCompareOp["GreaterThan"] = ">";
    KeyCompareOp["GreaterOrEqualThan"] = ">=";
    KeyCompareOp["LessThan"] = "<";
    KeyCompareOp["LessOrEqualThan"] = "<=";
})(KeyCompareOp || (KeyCompareOp = {}));
export function isKey(maybeKey) {
    return ((typeof maybeKey === 'number' && !Number.isNaN(maybeKey)) ||
        typeof maybeKey === 'string' ||
        (maybeKey instanceof Date && !Number.isNaN(maybeKey.getTime())) ||
        maybeKey instanceof ArrayBuffer ||
        ArrayBuffer.isView(maybeKey) ||
        (Array.isArray(maybeKey) && maybeKey.every(isKey)));
}
export function getKeyByPath(data, keyPath) {
    // todo extracting a key from a value using a key path (exp: a.b / [a.b, c.d])
    var objectData = data;
    if (Array.isArray(keyPath)) {
        return keyPath.map(function (i) { return objectData[i]; });
    }
    return objectData[keyPath];
}
export function equalsKeyPaths(pathX, pathY) {
    if (Array.isArray(pathX)) {
        return (Array.isArray(pathY) && pathX.length === pathY.length && pathX.every(function (path, i) { return equalsKeyPaths(path, pathY[i]); }));
    }
    return pathX === pathY;
}
//# sourceMappingURL=key.js.map